module.exports = __webpack_public_path__ + "static/img/page_logo.bd660044.png";